// extracted by mini-css-extract-plugin
export default {"headsetInfoItem":"styles_headsetInfoItem__kmR2I","title":"styles_title__AEgnw","description":"styles_description__V8YuG"};